import React, { useState, useEffect } from 'react';

export const Clock: React.FC = () => {
  const [t, setT] = useState(new Date());
  useEffect(() => { const id = setInterval(() => setT(new Date()), 1000); return () => clearInterval(id); }, []);
  return (
    <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text2)', fontVariantNumeric: 'tabular-nums' }}>
      {t.toLocaleTimeString('en-KW', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
    </span>
  );
};
